const DELIVERY_TIME_TEXT = `배송 소요 시간:`;
const TEXT_COLOR = `#288E7C`;
const SUFFIX_TEXT = `영업일`;

class BlockDeliveryTime extends HTMLElement {
    constructor() {
        super();
        this.state = {
            deliveryTime: "2~4",
        };
    }

    initState() {
        const deliveryTime = this.getAttribute(":deliveryTime");
        if (!!deliveryTime) {
            this.state = {
                deliveryTime,
            };
        }
    }

    updateDeliveryTime(currentVariant) {
        const productSection = document.querySelector('section.product-info');
        const sectionId = productSection.dataset.sectionId;
        const variantAccentuates = JSON.parse(document.querySelector(`#AccentuateJson-${sectionId}`).textContent);
        const accentuateData = variantAccentuates.find(({ variantId }) => +variantId === currentVariant.id);
        const deliveryTime = accentuateData?.accentuate?.delivery_time;

        if (!deliveryTime) {
            return;
        }

        this.updateState({ deliveryTime });
    }

    connectedCallback() {
        this.initState();
        this.render();
    }

    updateState(state) {
        this.state = {
            ...this.state,
            ...state
        }

        this.render();
    }

    render() {
        const { deliveryTime } = this.state;
        this.innerHTML = `
        <p>
            ${DELIVERY_TIME_TEXT}
            <span style="color: ${TEXT_COLOR}">
            <span id="delivery-time">${deliveryTime}</span>
            ${SUFFIX_TEXT}
            </span>
        </p>
      `;
    }
}

customElements.define("block-delivery-time", BlockDeliveryTime);
